import {
  FONTS_GRAPHIK_BOLD_WOFF,
  FONTS_GRAPHIK_BOLD_WOFF2,
  FONTS_GRAPHIK_LIGHT_WOFF,
  FONTS_GRAPHIK_LIGHT_WOFF2,
  FONTS_GRAPHIK_MEDIUM_WOFF,
  FONTS_GRAPHIK_MEDIUM_WOFF2,
  FONTS_GRAPHIK_REGULAR_WOFF,
  FONTS_GRAPHIK_REGULAR_WOFF2,
  FONTS_GRAPHIK_SEMIBOLD_WOFF,
  FONTS_GRAPHIK_SEMIBOLD_WOFF2,
} from './src/autogenerated/resources.autogenerated';

/*
 * CSS
 */

export const GLOBAL_CSS = `
  * {
    font-family: "Graphik", sans-serif;
  }

  *:focus {
    outline: 0;
  }

  html {
    scroll-padding-top: 100px;
    scroll-behavior: smooth;
  }

  body {
    margin: 0;
    color: black;
    font-size: 16px;
    background-color: white;
  }

  img, video {
    max-width: 100%;
    /* this is needed for responsive images */
    height: auto;
  }

  a {
    display: inline-block;
    color: #E52427;
    text-decoration: underline;
    text-decoration-thickness: 2px;
    transition: color 0.25s linear;
    cursor: pointer;
    font-weight: 500;
  }

  a:hover {
    text-decoration: underline;
    text-decoration-thickness: 2px;
    color: #FF383B;
  }

  button {
    font-size: 18px;
    cursor: pointer;
  }

  p {
    margin-top: 0;
    margin-bottom: 12px;
    min-height: 1em;
    line-height: 1.5em;
  }

  ::selection {
    color: black;
    background: #FCCDCA;
  }
  ::-moz-selection {
    color: black;
    background: #FCCDCA;
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }
  th {
    text-align: left;
  }

  small {
    font-size: 14px;
  }

  hr {
    margin: 1em 0 2em;
    border: none;
    border-top: 2px dashed #FCCDCA;
  }

  ul,
  ol {
    margin-bottom: 12px;
  }
  ul li p {
    margin-bottom: 4px;
  }

  /* for exampled used on /journalen/5-fordelar-med-min-doktor/ */
  ol {
    font-weight: 500;
    line-height: 1.2em;
    color: #FF383B;
  }
  ol li {
    margin-bottom: 16px;
  }
  ol li p {
    color: black;
    font-size: 16px;
    font-weight: normal;
  }

  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  ::-webkit-scrollbar-thumb {
    background: #C0C0C0;
    border-radius: 6px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: #FF4040;
  }
`.replace(/(\r\n|\n|\r)/gm, '');

export const GLOBAL_CSS_FONTS = `
  @font-face {
    font-family: "Graphik";
    src: url('${FONTS_GRAPHIK_LIGHT_WOFF2}') format("woff2"), url('${FONTS_GRAPHIK_LIGHT_WOFF}') format("woff");
    font-weight: 300;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: "Graphik";
    src: url('${FONTS_GRAPHIK_REGULAR_WOFF2}') format("woff2"), url('${FONTS_GRAPHIK_REGULAR_WOFF}') format("woff");
    font-weight: 400;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: "Graphik";
    src: url('${FONTS_GRAPHIK_MEDIUM_WOFF2}') format("woff2"), url('${FONTS_GRAPHIK_MEDIUM_WOFF}') format("woff");
    font-weight: 500;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: "Graphik";
    src: url('${FONTS_GRAPHIK_SEMIBOLD_WOFF2}') format("woff2"), url('${FONTS_GRAPHIK_SEMIBOLD_WOFF}') format("woff");
    font-weight: 600;
    font-style: normal;
    font-display: swap;
  }
  @font-face {
    font-family: "Graphik";
    src: url('${FONTS_GRAPHIK_BOLD_WOFF2}') format("woff2"), url('${FONTS_GRAPHIK_BOLD_WOFF}') format("woff");
    font-weight: 700;
    font-style: normal;
    font-display: swap;
  }
`.replace(/(\r\n|\n|\r)/gm, '');
